import { Component } from '@angular/core';
import { RouteDetailModalPresenter } from '../route-report-modal/route-detail-modal.presenter';

@Component({ selector: 'route-intermediate-stations-modal', templateUrl: './route-intermediate-stations-modal.component.html' })
export class RouteIntermediateStationsModalComponent extends RouteDetailModalPresenter {
  readonly kind = 'stations' as const;
}
